export default __webpack_public_path__ + "static/media/image-phone@3x.172127e6.webp";